import FormattedMessage from 'I18n/components/FormattedMessage';
import styled from 'styled-components';
import { NEUTRAL_600, NEUTRAL_700, NEUTRAL_800 } from 'visitor-ui-component-library/constants/WidgetColors';
import { hexToRgba } from 'visitor-ui-component-library/utils/hexToRgba';
import SVGLeft from 'visitor-ui-component-library-icons/icons/SVGLeft';
import { Section, SectionHeader } from './Section';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const UnstyledList = styled.ul.withConfig({
  displayName: "CategoriesList__UnstyledList",
  componentId: "sc-3afh8r-0"
})(["list-style:none;padding:0;margin:0;"]);
const CategoryItem = styled.button.withConfig({
  displayName: "CategoriesList__CategoryItem",
  componentId: "sc-3afh8r-1"
})(["text-align:left;display:flex;justify-content:space-between;align-items:center;color:currentColor;padding:8px;border-radius:6px;line-height:20px;border:none;background:transparent;transition:background-color 0.2s ease-in-out;width:100%;&:not(:disabled):hover,&:not(:disabled):focus{background-color:", ";}"], ({
  coloring: {
    useDefaultColor,
    accentColor
  }
}) => useDefaultColor ? hexToRgba(NEUTRAL_700, 0.1) : hexToRgba(accentColor, 0.05));
const CategoryItemName = styled.div.withConfig({
  displayName: "CategoriesList__CategoryItemName",
  componentId: "sc-3afh8r-2"
})(["font-weight:600;"]);
const CategoryItemCount = styled.div.withConfig({
  displayName: "CategoriesList__CategoryItemCount",
  componentId: "sc-3afh8r-3"
})(["font-weight:400;color:", ";display:flex;gap:4px;align-items:center;transition:color 0.2s ease-in-out;", ":hover &{color:", ";}"], NEUTRAL_600, CategoryItem, NEUTRAL_800);
const RowArrowIcon = styled(SVGLeft).withConfig({
  displayName: "CategoriesList__RowArrowIcon",
  componentId: "sc-3afh8r-4"
})(["fill:", ";transform:rotate(180deg);"], ({
  theme
}) => theme.colors.primary);
const CategoriesList = ({
  categories,
  coloring,
  onCategoryClick,
  disabled = false
}) => {
  if (!(categories !== null && categories !== void 0 && categories.length)) {
    return null;
  }
  return /*#__PURE__*/_jsxs(Section, {
    children: [/*#__PURE__*/_jsx(SectionHeader, {
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "conversations-visitor-experience-components.knowledgeBase.articleCategories.title"
      })
    }), /*#__PURE__*/_jsx(UnstyledList, {
      children: categories.map(({
        categoryId,
        categoryName,
        articleCount
      }) => /*#__PURE__*/_jsx("li", {
        children: /*#__PURE__*/_jsxs(CategoryItem, {
          onClick: () => onCategoryClick === null || onCategoryClick === void 0 ? void 0 : onCategoryClick(categoryId, categoryName),
          coloring: coloring,
          disabled: disabled,
          children: [/*#__PURE__*/_jsxs("div", {
            children: [/*#__PURE__*/_jsx(CategoryItemName, {
              children: categoryName
            }), /*#__PURE__*/_jsxs(CategoryItemCount, {
              children: [/*#__PURE__*/_jsx("span", {
                children: articleCount
              }), articleCount === 1 ? /*#__PURE__*/_jsx(FormattedMessage, {
                message: "conversations-visitor-experience-components.knowledgeBase.articleCategories.article"
              }) : /*#__PURE__*/_jsx(FormattedMessage, {
                message: "conversations-visitor-experience-components.knowledgeBase.articleCategories.articles"
              })]
            })]
          }), /*#__PURE__*/_jsx(RowArrowIcon, {})]
        })
      }, categoryId))
    })]
  });
};
CategoriesList.displayName = 'CategoriesList';
export default CategoriesList;